import {
    HOUR_IN_MS,
    MINUTE_IN_MS,
    QUARTER_HOUR_IN_MS,
    THIRTY_DAYS_IN_MS,
    YEAR_IN_MS,
    YEAR_IN_SECONDS,
} from './constants';

export interface CookieAttribute {
    expires: number;
    needOnBackend?: boolean;
}

export enum Cookie {
    IsDesktopSite = 'isDesktopSite',
    Lang = 'lang',
    Version = 'version',
    CookiesAllowedAt =  'cookiesAllowedAt',
    Session = 'session',
    ShowIncomeTooltip = 'showIncomeTooltip',
    ShowFavoritesTooltip = 'showFavoritesTooltip',
    Srv = 'srv',
    UtmSource = 'utm_source',
    Referrer = 'referrer',
    UtmMedium = 'utm_medium',
    UtmCampaign = 'utm_campaign',
    UtmContent = 'utm_content',
    UtmTerm = 'utm_term',
    IncarnateUserId = 'incarnateUserId',
    ClickId = 'clickId',
    AttributionChannel = 'attributionChannel',
    StatsId = 'statsId',
    QaIp = 'qaIp',
    OAuthQuery = 'oauthQuery',
    RefCode = 'refCode',
    Debug = 'debug',
    Experiments = 'experiments',
    QaExperiments = 'qaExperiments',
    QaDate = 'qaDate',
    IsStripChat = 'isStripChat',
    StreamingProvider = 'streamingProvider',
    QaTest = 'qaTest',
    Fp = 'Fp',
    Expff009 = 'expff009',
}

export const cookies: Record<Cookie, CookieAttribute> = {
    [Cookie.UtmMedium]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Lang]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Fp]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Version]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.UtmCampaign]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.UtmContent]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.UtmTerm]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.UtmSource]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Referrer]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.IsDesktopSite]: {
        expires: YEAR_IN_MS,
    },
    [Cookie.CookiesAllowedAt]: {
        expires: YEAR_IN_MS,
    },
    [Cookie.ShowIncomeTooltip]: {
        expires: YEAR_IN_MS,
    },
    [Cookie.ShowFavoritesTooltip]: {
        expires: YEAR_IN_MS,
    },
    [Cookie.Session]: {
        expires: YEAR_IN_SECONDS,
        needOnBackend: true,
    },
    [Cookie.Srv]: {
        expires: YEAR_IN_SECONDS,
    },
    [Cookie.IncarnateUserId]: {
        expires: QUARTER_HOUR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.ClickId]: {
        expires: THIRTY_DAYS_IN_MS,
        needOnBackend: true,
    },
    [Cookie.AttributionChannel]: {
        expires: HOUR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.StatsId]: {
        expires: HOUR_IN_MS * 8,
        needOnBackend: true,
    },
    [Cookie.QaIp]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.OAuthQuery]: {
        expires: MINUTE_IN_MS * 10,
        needOnBackend: true,
    },
    [Cookie.RefCode]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Debug]: {
        expires: THIRTY_DAYS_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Experiments]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.QaExperiments]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.QaDate]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.IsStripChat]: {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.StreamingProvider] : {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.QaTest] : {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    },
    [Cookie.Expff009] : {
        expires: YEAR_IN_MS,
        needOnBackend: true,
    }
}

export function parseCookies(origin: string): Record<string, string> {
    if (typeof origin !== 'string') {
        return {}
    }
    const allowedNames: string[] = Object.values(Cookie);
    return origin.split(';')
        .map((item: string) => item.trim().split('='))
        .reduce((parsedCookies: Record<string, string>, [name, value]: string[]) => {
            if (allowedNames.includes(name)) {
                parsedCookies[name] = value;
            }
            return parsedCookies;
        }, {});
}
